import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { adminApi, type StaffNotification } from '../api/admin';
import './NotificationBell.css';

/**
 * Yönetici (admin/manager) bildirim zili. Yeni bayi kaydı gibi olayları gösterir.
 * Zil açıldığında okunmamışlar "okundu" işaretlenir → bir daha rozet/bildirimde görünmez.
 */
export function NotificationBell() {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [items, setItems] = useState<StaffNotification[]>([]);
  const [unread, setUnread] = useState(0);
  const ref = useRef<HTMLDivElement>(null);

  const load = () =>
    adminApi.notifications().then((r) => { setItems(r.items); setUnread(r.unread); }).catch(() => {});

  useEffect(() => {
    load();
    const t = setInterval(load, 60_000); // yeni kayıtları periyodik yakala
    return () => clearInterval(t);
  }, []);

  useEffect(() => {
    if (!open) return;
    const onDoc = (e: MouseEvent) => { if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false); };
    const onKey = (e: KeyboardEvent) => e.key === 'Escape' && setOpen(false);
    document.addEventListener('mousedown', onDoc);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onDoc);
      document.removeEventListener('keydown', onKey);
    };
  }, [open]);

  const toggle = async () => {
    const next = !open;
    setOpen(next);
    // Açılışta gösterilenler "okundu" olur; rozet temizlenir, tekrar gösterilmez.
    if (next && unread > 0) {
      try { await adminApi.markNotificationsRead(); setUnread(0); } catch { /* yok say */ }
    }
  };

  const go = (n: StaffNotification) => {
    setOpen(false);
    if (n.type === 'new_dealer') navigate('/panel/bayiler');
  };

  return (
    <div className="notif" ref={ref}>
      <button className="notif-btn" onClick={toggle} aria-label="Bildirimler" aria-expanded={open}>
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <path d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9" />
          <path d="M13.7 21a2 2 0 0 1-3.4 0" />
        </svg>
        {unread > 0 && <span className="notif-badge">{unread > 9 ? '9+' : unread}</span>}
      </button>

      {open && (
        <div className="notif-pop" role="menu">
          <div className="notif-head">Bildirimler</div>
          {items.length === 0 ? (
            <div className="notif-empty">Yeni bildirim yok.</div>
          ) : (
            <div className="notif-list">
              {items.map((n) => (
                <button key={n.id} className="notif-item" onClick={() => go(n)}>
                  <div className="notif-item-title">{n.title}</div>
                  {n.body && <div className="notif-item-body">{n.body}</div>}
                </button>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
